import ContactComponent from "./components/contact-component";
import {render, RenderPosition} from "./utils/render";

export const renderContactContent = (container, data) => {
  container.innerHTML = ``;
  const contactComponent = new ContactComponent({data});

  render(container, contactComponent.getElement(), RenderPosition.BEFOREEND);

  window.ymaps.ready(init);
  let x;
  let y;
  let myMap;
  let myPlacemark;
  x = data.x;
  y = data.y;
  function init() {
    myMap = new window.ymaps.Map(`YMapsID`, {
      center: [x, y],
      zoom: 16
    });
    myPlacemark = new window.ymaps.Placemark([x, y],
        {
          hintContent: `Пункт выдачи в ${data.town_p}`,
          balloonContent: `Пункт выдачи <b>${data.domain}</b> в ${data.town_p}<br><b>Адрес:</b> ${data.addr}<br><b>Телефон:</b> ${data.phone_full}<br><b>Режим работы:</b><br>${data.worktime}`
        },
        {
          iconLayout: `default#image`,
          iconImageHref: `img/mapicon/${data.domain}.png`,
          iconImageSize: [30, 60],
          iconImageOffset: [-15, -55]
        }
    );
    myMap.geoObjects.add(myPlacemark);
  }
};
